import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthVerify() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    (async () => {
      try {
        const res = await api("/auth/verify", { method: "POST", body: { token } });
        navigate(res.user?.is_admin ? "/admin" : "/", { replace: true });
        window.location.reload();
      } catch (err) {
        setError(err.message);
      }
    })();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-cfhtb-bg flex items-center justify-center px-4">
      <div className="bg-white rounded-lg border border-cfhtb-light/30 shadow-sm p-8 max-w-md w-full text-center">
        {error ? (
          <>
            <h1 className="font-serif text-xl font-semibold text-cfhtb-heading">Lien invalide</h1>
            <p className="text-sm text-cfhtb-text mt-3" data-testid="auth-error-message">{error}</p>
            <button
              data-testid="auth-retry-button"
              onClick={() => navigate("/connexion")}
              className="mt-6 bg-cfhtb-primary text-white rounded-md px-4 py-2 text-sm font-medium hover:bg-[#1f1975] transition-colors"
            >
              Demander un nouveau lien
            </button>
          </>
        ) : (
          <>
            <div className="h-8 w-8 mx-auto border-2 border-cfhtb-primary border-t-transparent rounded-full animate-spin" />
            <p className="text-sm text-cfhtb-text mt-4">Connexion en cours…</p>
          </>
        )}
      </div>
    </div>
  );
}
